export const CDN_URL = "https://cdn.heliumbuilder.com";
